import { FailureActionType, WidgetTypeEnum } from "../../common/enum";
import ResponseMapModel from "./ResponseMapModel";
import AudioFileModel from "./AudioFileModel";
import WidgetBaseDetailModel from "./WidgetBaseDetailModel";

export default class PickLanguageWidgetModel extends WidgetBaseDetailModel {
	public timeout: number;
	public messageText: string;
	public audioFile: AudioFileModel;
	public responseMap: ResponseMapModel[];
	public maxRetries: number;
	public retryMessage: string;
	public retryAudioFile: AudioFileModel;
	public failureActionType: FailureActionType | string;
	public failureDefaultValue: string;
	public failureMessage: string;
	public failureAudioFile: AudioFileModel;
	public nextAction: string;

	public constructor() {
		super();
		this.id = "PickLanguage";
		this.label = "Pick Language";
		this.type = WidgetTypeEnum.PickLanguage;
		this.variableName = "language";
		this.timeout = 0;
		this.messageText = "";
		this.audioFile = new AudioFileModel();
		this.responseMap = [];
		this.maxRetries = 0;
		this.retryMessage = "";
		this.retryAudioFile = new AudioFileModel();
		this.failureActionType = "";
		this.failureDefaultValue = "";
		this.failureMessage = "";
		this.failureAudioFile = new AudioFileModel();
		this.nextAction = "";
	}
}
